import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { database } from "../../database/firebase";

const useRequestId = (roomId) => {
  const [requestData, setRequestData] = useState([]);

  useEffect(() => {
    const getRequestData = async () => {
      try {
        onSnapshot(
          query(
            collection(database, "userRooms", roomId, "request"),
            orderBy("timestamp", "desc")
          ),
          (snapshot) => {
            setRequestData(
              snapshot.docs.map((doc) => ({
                data: doc.data(),
                id: doc.id,
              }))
            );
          }
        );
      } catch (error) {
        alert(error.message);
      }
    };

    getRequestData();
  }, [roomId]);

  return [requestData];
};

export default useRequestId;
